import './Main.css';
import BridgeForm from './Table.tsx';

const Main = () => {
    return (
        <main>
            <BridgeForm/>
        </main>
    )
}

export default Main;